import React, { useEffect, useRef, useMemo } from 'react'
import { useHistory } from 'react-router'
import { searchEsProduct } from '../../../api'
import distributorApi from '../../../api/distributor'
import { DistributorInventoryModel, ProductModel } from '../../../models'
import { LpFilter, LpWhere } from '../../../models/lp-filter'
import { debounce, formatPrice, useAsync } from '../../../utils'
import useViewModel from '../../../viewModel/base'
import distributorVM from '../../../viewModel/distributor'
import Loading from '../../shared/Loading'

import { useRecoilValue } from "recoil";
import { accountDataState } from "../../../recoil/account";

const CONFIG = {
    LIMIT: 10
}

const DistributorInventory = () => {
    const history = useHistory()
    const searchInputRef = useRef<any>()

    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType === 'ADMIN')
            return accountInfo.doctor.mId
    }, [accountInfo])

    const { execute: getDistributorInventories, status: getDistributorInventoriesStatus } = useAsync(distributorApi.getDistributorInventories)
    const { execute: getDistributorInventoriesCount, value: count } = useAsync(distributorApi.getDistributorInventoriesCount)
    const { execute: searchProductAsync, value: productES } = useAsync(searchEsProduct)

    const viewModel = useViewModel({
        searchTerm: '',
        offset: 0,
        distributorInventories: [] as DistributorInventoryModel[]
    })

    useEffect(() => {
        if (viewModel.data.distributorInventories.length === 0) return
        searchProductAsync(getQuery())
    }, [viewModel.data.distributorInventories])

    useEffect(() => {
        getDistributorInventoriesCount(getWhereCondition(), adminId)
        getDistributorInventories(getFilterCondition(), adminId)
            .then(res => {
                viewModel.updateData({ distributorInventories: res })
            })
    }, [viewModel.data.searchTerm])

    useEffect(() => {
        if (!viewModel.data.offset) return

        getDistributorInventories(getFilterCondition(), adminId)
            .then(res => {
                viewModel.updateData({
                    distributorInventories: [
                        ...viewModel.data.distributorInventories,
                        ...res,
                    ]
                })
            })
    }, [viewModel.data.offset])

    const getQuery = () => {
        return {
            from: 0,
            size: viewModel.data.distributorInventories?.length,
            _source: ["name", "imageUrls", "pageUrl", '_id'],
            query: {
                "bool": {
                    "should": viewModel.data.distributorInventories?.map(item => {
                        return {
                            term: {
                                _id: item.mProductId
                            }
                        }
                    })
                }
            }
        }
    }

    const getWhereCondition = (): LpWhere => {
        let where: LpWhere = {
            and: [{
                mStatus: "ACTIVE"
            }]
        };

        if (viewModel.data.searchTerm) {
            where.and!.push({
                mProductName: { regexp: `/${viewModel.data.searchTerm}/i` }
            })
        }

        if (!where.and?.length) {
            return {}
        }

        return where
    }

    const getFilterCondition = (): LpFilter => {
        const { searchTerm, offset } = viewModel.data

        let filter: LpFilter = {
            offset: offset,
            limit: CONFIG.LIMIT,
            include: [{ relation: "mDistributor" }],
        }

        const where = getWhereCondition()

        // if (searchTerm) {
        filter.where = where
        // }

        return filter
    }

    const onSearch = debounce((value: string) => {
        viewModel.updateData({ searchTerm: value, offset: 0 })
    }, 500)

    const loadMore = () => {
        viewModel.updateData({ offset: viewModel.data.offset + CONFIG.LIMIT })
    }

    return <div id="main">
        <div className="container">
            <div className="form-search mb-4">
                <form id="search" onSubmit={e => { e.preventDefault(); }}>
                    <input ref={searchInputRef} type="text" autoComplete='off' name="search" placeholder="Tìm sản phẩm" className="input-search" onChange={e => {
                        onSearch(e.target.value)
                    }} />
                    <a onClick={() => {
                        searchInputRef.current.value = ''
                        onSearch("")
                    }} id="btn-search-clear">
                        <img src="./images/cancel.svg" title="Xóa" className="img-fluid" width={24} />
                    </a>
                    <button type="button" className="btn-search">
                        <img src="./images/search.svg" title="Tìm kiếm" className="img-fluid" width={24} />
                    </button>
                </form>
            </div>
            {
                getDistributorInventoriesStatus === 'loading' &&
                <div className="wrap-loading">
                    <Loading />
                </div>
            }
            {
                getDistributorInventoriesStatus === 'ready' && viewModel.data.distributorInventories.length === 0 &&
                <p className='text-center'>Không tìm thấy sản phẩm</p>
            }
            <div className="products-list" id="main-content">
                {
                    viewModel.data.distributorInventories?.map((item, index) => {

                        const product = productES?.data?.find((product: ProductModel) => product._id === item.mProductId)
                        const img = product?.imageUrls && product?.imageUrls[0]

                        return <div key={`${item.mProductId}-${index}`} className="product-summary d-flex" onClick={() => history.push(`/distributor-inventory-detail?distributorId=${item.mDistributorId}&productId=${item.mProductId}&distributorInventoryId=${item.mId}`)}>
                            <div className="product-thumb float-none w-25" style={{ maxWidth: '90px' }}>
                                <img src={img || ''} className="img-fluid" width={75} />
                            </div>
                            <div className="w-75">
                                <strong>{item.mProductName}</strong><br />
                                <small>Nhà phân phối: {item?.mDistributor?.mName}</small><br />
                                <strong className="txt-orange">{formatPrice(distributorVM.getDitributorInvPrice(item.mPrice, item.mDiscountPrice, item.mDiscountStatus))} đ/ {item.mPkgName}</strong>
                                {
                                    !!distributorVM.getDitributorInvBeforeDiscountPrice(item.mPrice, item.mDiscountPrice, item.mDiscountStatus) &&
                                    <div className='d-flex w-100 align-items-center'>
                                        <div style={{ color: '#707070', textDecoration: 'line-through', whiteSpace: 'nowrap', fontSize: 13 }}>
                                            {formatPrice(distributorVM.getDitributorInvBeforeDiscountPrice(item.mPrice, item.mDiscountPrice, item.mDiscountStatus))} đ/ {item.mPkgName}
                                        </div>
                                        <div className='ml-2 discount-mark'>
                                            Giảm chiết khấu
                                        </div>
                                    </div>
                                }
                                {
                                    item.mDiscountHtml && item.mDiscountHtml.trim() ?
                                        <div className='discount-mark'>
                                            Khuyến mãi
                                        </div> : null
                                }
                            </div>
                        </div>
                    })
                }
                {
                    viewModel.data.distributorInventories?.length < count &&
                    <div className="d-flex mt-2 justify-content-center">
                        <button className="btn p-1 px-2" style={{ fontSize: 13 }} onClick={loadMore}>Xem thêm</button>
                    </div>
                }
                <div style={{ height: 52 }}>
                    <div className="fixed-button d-flex justify-content-center" style={{ padding: '0.75rem 1rem', boxShadow: '0px 3px 12px rgba(0, 0, 0, 0.29)' }}>
                        <small className="text-center blue-txt">Sản phẩm giá ưu đãi được cung cấp bởi các nhà phân phối liên kết với Medigo</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default DistributorInventory